/* MELYSIUM: Warenkorb-Geschenke ab Warenkorbwert (Umbau 15.10.2026, vorher nur Leinen-Beutel;
   Duftwahl Body Butter 28.10.2026, Honigschokolade 29.10.2026).
   Stufen kommen aus window.mlysGeschenke (snippets/meta-tags.liquid), Schwellen und
   Aktionszeiten aus snippets/mlys-phase.liquid:
     Leinen-Beutel        immer, EUR 100 / CHF 95
     Body Butter          Black Week (Mi 25.11. bis So 29.11.2026) und Early Access
                          ab Di 24.11. 18:00 (nur mit Rabattcode im Warenkorb), EUR 80 / CHF 75.
                          Duft waehlt der Kunde im Warenkorb (Vanille / Bergamotte / Pure),
                          gespeichert im Warenkorb-Attribut _mlys_bb_duft, Standard Vanille.
                          Ist das Kontingent eines Dufts leer (bbFrei false oder Shopify
                          lehnt das Hinzufuegen ab), nimmt das Skript ohne Klick den
                          naechsten freien Duft in der Reihenfolge Vanille, Pure,
                          Bergamotte (Tim 03.11.2026: Vanille max. 60 Geschenke, danach
                          sofort Pure; niemand darf ohne die versprochene Body Butter
                          bleiben). Vorher fiel die Wahl immer auf Vanille zurueck, bei
                          leerer Vanille kam gar keine Body Butter in den Warenkorb.
     Honigschokolade      wie Body Butter, EUR 125 / CHF 120, solange Bestand da ist
     getoenter Lip Balm   nur Weihnachten, sobald eine Variante eingetragen ist
   Jedes Geschenk ist ein eigenes Produkt zu 0,00 mit Vergleichspreis (kein Rabatt:
   Rapid Bundle belegt die Produktrabatt-Funktion).

   Gerechnet wird auf cart.total_price (Zahlbetrag nach Mengenrabatten und Codes)
   abzueglich aller Geschenk-Zeilen. Pro Geschenk laufen beide Richtungen: Stufe
   erreicht und nicht drin = hinzufuegen, nicht erreicht oder Stufe aus und drin =
   entfernen. "alle" enthaelt jede Geschenk-Variante, auch inaktive, damit z. B.
   die Body Butter nach der Black Week oder beim Laenderwechsel wieder rausfliegt
   und beim Duftwechsel die alte Variante verschwindet.

   Ereignis "mlys:warenkorb" (z. B. vom Kampagnen-Header, nachdem BLACK20
   automatisch eingeloest wurde) startet einen neuen Abgleich.
   Duft-Dropdown (data-mlys-duft-select, seit 29.10.; vorher Knoepfe data-mlys-duft) rendert snippets/mlys-ship-banner.liquid
   serverseitig; dieses Skript setzt nur das Attribut und gleicht ab, es
   zeichnet nichts selbst. Jubel, Feuerwerk, fluessiger Balken, Scrollposition und
   iOS-Seitensperre (29.10.): siehe unten. */
(function () {
  var KONFIG = window.mlysGeschenke || {};
  var STUFEN = KONFIG.stufen || [];
  var ALLE = KONFIG.alle || [];
  var BB = KONFIG.bb || {};
  var BB_FREI = KONFIG.bbFrei || {};
  var WAEHRUNG = KONFIG.waehrung || 'EUR';
  var PROP_KEY = 'Geschenk';
  var DUFT_ATTR = '_mlys_bb_duft';
  var DUFT_STANDARD = 'Vanille';
  var DUFT_REIHE = ['Vanille', 'Pure', 'Bergamotte'];
  var DUFT_LEER = {}; /* Duefte, deren Hinzufuegen Shopify auf dieser Seite abgelehnt hat (422) */
  var GESCHENK_LEER = {}; /* andere Geschenk-Varianten, die Shopify auf dieser Seite abgelehnt hat (422) */

  var laeuft = false;
  var nochmal = false;
  var originalFetch = window.fetch;

  function geld(cent) {
    var text;
    try {
      text = new Intl.NumberFormat('de-DE', { style: 'currency', currency: WAEHRUNG }).format(cent / 100);
    } catch (e) {
      text = (cent / 100).toFixed(2).replace('.', ',') + WAEHRUNG;
    }
    /* Kein Leerzeichen vor dem Waehrungszeichen (Tim 28.10.2026): 80,00€ */
    return text.replace(/[\s  ]+/g, '');
  }

  function sectionIds() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try {
        return drawer.getSectionsToRender().map(function (s) { return s.id; });
      } catch (e) {}
    }
    return ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text', 'main-cart-items', 'main-cart-footer'];
  }

  /* Drawer-Inhalt still ersetzen (ohne ihn zu oeffnen). Wartet, bis Dawns
     cart-drawer definiert ist: beim Seitenaufruf laeuft dieses Skript sonst
     vor cart-drawer.js und der Geschenkblock bliebe veraltet (Befund 29.10.).
     Danach den Klick aufs Overlay wieder anhaengen (wie Dawns renderContents). */
  function neuRendern(antwort) {
    if (window.location.pathname.indexOf('/cart') === 0) { window.location.reload(); return; }
    if (!antwort || !antwort.sections) return;
    var los = function () {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.getSectionsToRender !== 'function' || typeof drawer.getSectionInnerHTML !== 'function') return;
      merkeScroll();
      drawer.getSectionsToRender().forEach(function (s) {
        var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
        if (el && antwort.sections[s.id]) el.innerHTML = drawer.getSectionInnerHTML(antwort.sections[s.id], s.selector);
      });
      var leer = !document.querySelector('#CartDrawer tr.cart-item');
      drawer.classList.toggle('is-empty', leer);
      var overlay = document.querySelector('#CartDrawer-Overlay');
      if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
      scrollHalten();
    };
    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements.whenDefined('cart-drawer').then(los);
    } else {
      los();
    }
  }

  function post(pfad, daten, mitSections) {
    if (mitSections) {
      daten.sections = sectionIds().join(',');
      daten.sections_url = window.location.pathname;
    }
    return originalFetch(pfad, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(daten)
    }).then(function (r) { return r.json(); });
  }

  function istGeschenk(variantId) {
    return ALLE.indexOf(variantId) !== -1;
  }

  function duftFrei(duft) {
    return !!BB[duft] && BB_FREI[duft] !== false && !DUFT_LEER[duft];
  }

  function duftVon(variantId) {
    for (var d in BB) { if (BB[d] === variantId) return d; }
    return null;
  }

  /* Gewaehlter Duft, sonst der erste freie in DUFT_REIHE. null = alle leer. */
  function bbDuft(warenkorb) {
    var wahl = (warenkorb.attributes && warenkorb.attributes[DUFT_ATTR]) || DUFT_STANDARD;
    if (duftFrei(wahl)) return wahl;
    for (var i = 0; i < DUFT_REIHE.length; i++) {
      if (duftFrei(DUFT_REIHE[i])) return DUFT_REIHE[i];
    }
    return null;
  }

  function bbVariante(warenkorb) {
    var duft = bbDuft(warenkorb);
    return duft ? BB[duft] : null;
  }

  function abgleichen(immerRendern) {
    if (laeuft) { nochmal = true; return Promise.resolve(); }
    laeuft = true;
    return originalFetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (warenkorb) {
        var restwert = warenkorb.total_price;
        var drin = {};
        warenkorb.items.forEach(function (item) {
          if (istGeschenk(item.variant_id)) {
            restwert -= item.final_line_price;
            (drin[item.variant_id] = drin[item.variant_id] || []).push(item);
          }
        });

        /* Stufen auf konkrete Varianten aufloesen (Body Butter nach Duftwahl) */
        var aktiv = STUFEN.map(function (s) {
          if (s.gruppe === 'bb') return { ab: s.ab, variante: bbVariante(warenkorb), bb: true };
          return s;
        }).filter(function (s) { return !!s.variante; });

        var updates = {};
        var aenderung = false;
        var hinzu = [];

        ALLE.forEach(function (variante) {
          var stufe = null;
          aktiv.forEach(function (s) { if (s.variante === variante) stufe = s; });
          var soll = !!(stufe && restwert >= stufe.ab);
          var zeilen = drin[variante] || [];
          if (soll && zeilen.length === 0 && !GESCHENK_LEER[variante]) {
            var props = {};
            props[PROP_KEY] = 'ab ' + geld(stufe.ab) + ' gratis';
            hinzu.push({ id: variante, quantity: 1, properties: props, bb: !!stufe.bb });
          }
          zeilen.forEach(function (zeile, i) {
            var menge = soll && i === 0 ? 1 : 0;
            if (zeile.quantity !== menge) { updates[zeile.key] = menge; aenderung = true; }
          });
        });

        if (!aenderung && hinzu.length === 0) {
          if (immerRendern) {
            /* leeres Update liefert die frisch gerenderten Drawer-Sections mit */
            return post('/cart/update.js', { updates: {} }, true)
              .then(function (antwort) { if (antwort && !antwort.status) neuRendern(antwort); });
          }
          return;
        }
        var kette = Promise.resolve(null);
        if (aenderung) {
          kette = kette.then(function () { return post('/cart/update.js', { updates: updates }, hinzu.length === 0); });
        }
        if (hinzu.length) {
          /* Nachkontrolle 1,5 s nach jedem Einlegen (01.11.2026): wechselt der Kunde waehrend
             des Einlegens die Seite, legt die neue Seite gleichzeitig ein, das Geschenk stand
             dann 2x im Warenkorb (Stresstest Rapi-Ersatz). Die zweite Runde setzt es auf 1. */
          setTimeout(abgleichen, 1500);
          /* Jedes Geschenk in einer eigenen Anfrage (03.11.2026, Pruef-Agent): eine Sammel-Anfrage
             scheitert komplett, wenn ein einziges Geschenk keinen Bestand mehr hat. Dann fehlte auch
             der Beutel, und die Nachkontrolle versuchte es alle 1,5 s erneut. Lehnt Shopify ein
             Geschenk ab (422 = kein Bestand), wird nur dieses fuer die Seite gesperrt; bei der
             Body Butter wird der naechste freie Duft gesetzt (Dropdown zeigt dann den echten Duft).
             Endet spaetestens, wenn alle Duefte gesperrt sind. */
          var letzte = null;
          hinzu.forEach(function (h, i) {
            var mitSections = i === hinzu.length - 1;
            kette = kette.then(function () {
              return post('/cart/add.js', { items: [{ id: h.id, quantity: h.quantity, properties: h.properties }] }, mitSections);
            }).then(function (antwort) {
              if (antwort && antwort.status === 422) {
                nochmal = true;
                if (h.bb) {
                  var leerDuft = duftVon(h.id);
                  if (leerDuft) DUFT_LEER[leerDuft] = true;
                  var attr = {};
                  attr[DUFT_ATTR] = bbDuft({ attributes: {} }) || DUFT_STANDARD;
                  return post('/cart/update.js', { attributes: attr }, false).then(function () { return null; });
                }
                GESCHENK_LEER[h.id] = true;
                return null;
              }
              if (antwort && !antwort.status) letzte = antwort;
              return null;
            });
          });
          kette = kette.then(function () { return letzte; });
        }
        return kette.then(function (antwort) {
          if (antwort && antwort.status) return; /* Fehler (z. B. 422), nicht endlos wiederholen */
          if (antwort) neuRendern(antwort);
        });
      })
      .catch(function () {})
      .then(function () {
        laeuft = false;
        if (nochmal) { nochmal = false; return abgleichen(true); }
      });
  }

  window.fetch = function () {
    var ziel = arguments[0];
    var adresse = ziel && ziel.url ? ziel.url : ziel;
    if (typeof adresse === 'string' && /\/cart\/(add|change|update|clear)/.test(adresse)) merkeScroll();
    var versprechen = originalFetch.apply(this, arguments);
    if (typeof adresse === 'string' && /\/cart\/(add|change|update|clear)/.test(adresse) && !laeuft) {
      versprechen.then(function () { setTimeout(abgleichen, 120); }).catch(function () {});
    }
    return versprechen;
  };

  document.addEventListener('mlys:warenkorb', function () { setTimeout(abgleichen, 400); });

  /* Duft-Knoepfe im Geschenkblock: Attribut setzen, dann tauscht abgleichen() die Variante */
  document.addEventListener('click', function (e) {
    var knopf = e.target && e.target.closest ? e.target.closest('[data-mlys-duft]') : null;
    if (!knopf) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (knopf.getAttribute('aria-pressed') === 'true') return;
    var duft = knopf.getAttribute('data-mlys-duft');
    var block = knopf.closest('.mlys-gifts');
    if (block) block.classList.add('is-loading');
    originalFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _mlys_bb_duft: duft } })
    }).then(function () { return abgleichen(true); }).catch(function () {});
  }, true);

  /* Duft-Dropdown im Geschenkblock (29.10.2026, statt Knoepfen). Capture auf
     document und stopImmediatePropagation, damit Dawns cart-drawer-items das
     change-Ereignis nicht als Mengenaenderung behandelt. */
  document.addEventListener('change', function (e) {
    var feld = e.target && e.target.matches && e.target.matches('[data-mlys-duft-select]') ? e.target : null;
    if (!feld) return;
    e.stopImmediatePropagation();
    var block = feld.closest('.mlys-gifts');
    if (block) block.classList.add('is-loading');
    originalFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _mlys_bb_duft: feld.value } })
    }).then(function () { return abgleichen(true); }).catch(function () {});
  }, true);

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[href*="cart"], cart-drawer, #cart-icon-bubble, .quantity__button, cart-remove-button')) {
      setTimeout(abgleichen, 350);
    }
  }, true);

  /* Jubel und fluessiger Balken (29.10.2026, abends ueberarbeitet).
     Der Drawer wird bei jeder Aenderung neu gerendert, oft zweimal kurz
     hintereinander (Dawn rendert, dann kommt ein Geschenk dazu). Deshalb:
     1. Balken: das Skript merkt sich, wo die Fuellung gerade optisch steht
        (laufende Animation mit Start, Ziel und Startzeit). Das neue Element
        startet an genau dieser Stelle und gleitet per transition zum neuen
        Wert. Kein Springen, kein Neustart.
     2. Jubel (Punkt springt, Block leuchtet) nur, wenn ein Ziel neu
        erreicht wurde. Rendert es waehrend des Jubels nochmal, laeuft die
        Animation ueber --mlys-seit an der gleichen Stelle weiter.
        Dazu ein Feuerwerk am neuen Punkt (Tim 29.10. abends: vorher kaum zu
        sehen). Es liegt als eigene Ebene ueber der Seite (position fixed,
        klickt nicht), damit ein Neu-Rendern es nicht abbricht.
     3. Scrollposition der Produktliste bleibt erhalten. Gemerkt wird sie bei
        jedem Scrollen, bei jedem Tippen in den Warenkorb und direkt vor jeder
        Warenkorb-Anfrage (iOS meldet Schwung-Scrollen nicht zuverlaessig).
        Gesetzt wird sie direkt im MutationObserver (vor dem Zeichnen) und im
        naechsten Frame nochmal (Tim 29.10.: Warenkorb sprang nach oben).
     Nur Animations-Klassen, Inline-Breite des Balkens und scrollTop, keine
     Layout-Aenderung. */
  var DAUER = 700;
  var lauf = null; /* { von, nach, start } in Prozent und ms */
  var jubelStart = 0;
  var jubelIndex = [];
  var scrollMerk = { top: 0, zeit: 0 };
  var jubelTimer = null;
  var fwTimer = null;

  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
  function standJetzt() {
    if (!lauf) return null;
    var t = Math.min(1, (Date.now() - lauf.start) / DAUER);
    return lauf.von + (lauf.nach - lauf.von) * easeOut(t);
  }

  function liste() {
    return document.querySelector('#CartDrawer cart-drawer-items') || document.querySelector('cart-drawer-items');
  }
  function merkeScroll() {
    var l = liste();
    if (l && l.isConnected && document.querySelector('cart-drawer.active')) {
      if (l.scrollTop > 0 || !l.getAttribute('data-mlys-frisch')) scrollMerk = { top: l.scrollTop, zeit: Date.now() };
    }
  }
  document.addEventListener('scroll', function (e) {
    var l = liste();
    if (l && e.target === l) { l.removeAttribute('data-mlys-frisch'); scrollMerk = { top: l.scrollTop, zeit: Date.now() }; }
  }, true);
  ['touchstart', 'pointerdown', 'click'].forEach(function (art) {
    document.addEventListener(art, function (e) {
      if (e.target && e.target.closest && e.target.closest('cart-drawer')) merkeScroll();
    }, { capture: true, passive: true });
  });

  function scrollHalten() {
    var l = liste();
    if (l && !l.getAttribute('data-mlys-scroll')) {
      l.setAttribute('data-mlys-scroll', '1');
      l.setAttribute('data-mlys-frisch', '1');
      if (scrollMerk.top > 0 && Date.now() - scrollMerk.zeit < 120000 && document.querySelector('cart-drawer.active')) {
        var ziel = scrollMerk.top;
        l.scrollTop = ziel;
        var nochmalSetzen = function () { var n = liste(); if (n === l && Math.abs(n.scrollTop - ziel) > 2) n.scrollTop = ziel; };
        if (window.requestAnimationFrame) window.requestAnimationFrame(nochmalSetzen);
        setTimeout(nochmalSetzen, 60);
      }
    }
  }

  function feuerwerk(index) {
    try { if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; } catch (e) {}
    if (!document.querySelector('cart-drawer.active')) return;
    var punkte = document.querySelectorAll('#CartDrawer .mlys-ship__cp.is-reached .mlys-ship__dot');
    var dot = punkte[index] || punkte[punkte.length - 1];
    if (!dot) return;
    var r = dot.getBoundingClientRect();
    if (!r.width) return;
    if (!document.getElementById('mlys-fw-stil')) {
      var st = document.createElement('style');
      st.id = 'mlys-fw-stil';
      st.textContent = '.mlys-fw{position:fixed;width:0;height:0;pointer-events:none;z-index:2147483000}' +
        '.mlys-fw i{position:absolute;left:0;top:0;width:var(--s);height:var(--s);margin:calc(var(--s) / -2) 0 0 calc(var(--s) / -2);border-radius:50%;background:var(--c);box-shadow:0 0 6px var(--c);animation:mlys-fw-flug var(--d) cubic-bezier(.12,.8,.3,1) forwards}' +
        '.mlys-fw b{position:absolute;left:-24px;top:-24px;width:48px;height:48px;border-radius:50%;border:3px solid #f3c27a;animation:mlys-fw-ring .8s ease-out forwards}' +
        '@keyframes mlys-fw-flug{0%{transform:translate(0,0) scale(1.2);opacity:1}65%{opacity:1}100%{transform:translate(var(--x),var(--y)) scale(.5);opacity:0}}' +
        '@keyframes mlys-fw-ring{0%{transform:scale(.3);opacity:1}100%{transform:scale(3);opacity:0}}';
      document.head.appendChild(st);
    }
    var box = document.createElement('div');
    box.className = 'mlys-fw';
    box.setAttribute('aria-hidden', 'true');
    box.style.left = (r.left + r.width / 2) + 'px';
    box.style.top = (r.top + r.height / 2) + 'px';
    var farben = ['#f3c27a', '#ff9f43', '#f4efe8', '#ffffff', '#ffd27a', '#e8a04a', '#ad5000'];
    var html = '<b></b>';
    for (var i = 0; i < 40; i++) {
      var w = (Math.PI * 2 * i) / 40 + Math.random() * 0.25;
      var weite = 55 + Math.random() * 75;
      var x = Math.cos(w) * weite;
      var y = Math.sin(w) * weite + 30;
      html += '<i style="--x:' + x.toFixed(1) + 'px;--y:' + y.toFixed(1) + 'px;--s:' + (5 + Math.random() * 5).toFixed(1) + 'px;--c:' + farben[i % farben.length] + ';--d:' + Math.round(900 + Math.random() * 600) + 'ms"></i>';
    }
    box.innerHTML = html;
    document.body.appendChild(box);
    setTimeout(function () { if (box.parentNode) box.parentNode.removeChild(box); }, 1800);
  }

  function jubel() {
    var ship = document.querySelector('#CartDrawer .mlys-ship') || document.querySelector('.mlys-ship');
    scrollHalten();
    if (!ship || ship.getAttribute('data-mlys-gesehen')) return;
    ship.setAttribute('data-mlys-gesehen', '1');
    var erreicht = ship.querySelectorAll('.mlys-ship__cp.is-reached');
    var fill = ship.querySelector('.mlys-ship__fill');
    var pct = fill ? parseFloat(fill.style.width) || 0 : 0;
    var alt = null;
    try { alt = JSON.parse(window.sessionStorage.getItem('mlysShip') || 'null'); } catch (e) {}
    try { window.sessionStorage.setItem('mlysShip', JSON.stringify({ n: erreicht.length, pct: pct })); } catch (e) {}

    /* 1. Balken fluessig vom optischen Stand aus */
    var von = standJetzt();
    if (von === null && alt) von = alt.pct;
    if (fill && von !== null && Math.abs(von - pct) > 0.5) {
      fill.style.transition = 'none';
      fill.style.width = von + '%';
      void fill.offsetWidth;
      fill.style.transition = 'width ' + DAUER + 'ms cubic-bezier(0.33, 1, 0.68, 1)';
      fill.style.width = pct + '%';
      lauf = { von: von, nach: pct, start: Date.now() };
    } else {
      lauf = { von: pct, nach: pct, start: Date.now() };
    }

    /* 2. Jubel neu oder fortsetzen */
    var seit = Date.now() - jubelStart;
    if (alt && erreicht.length > alt.n) {
      jubelStart = Date.now();
      jubelIndex = [];
      for (var i = alt.n; i < erreicht.length; i++) jubelIndex.push(i);
      seit = 0;
      try { if (navigator.vibrate) navigator.vibrate(30); } catch (e) {}
      var ziel = jubelIndex[jubelIndex.length - 1];
      clearTimeout(fwTimer);
      fwTimer = setTimeout(function () { feuerwerk(ziel); }, 600);
    } else if (seit > 2500) {
      return;
    }
    if (!jubelIndex.length) return;
    var sek = (seit / 1000).toFixed(2) + 's';
    var block = document.querySelector('#CartDrawer .mlys-gifts') || document.querySelector('.mlys-gifts');
    ship.style.setProperty('--mlys-seit', sek);
    jubelIndex.forEach(function (k) { if (erreicht[k]) erreicht[k].classList.add('is-neu'); });
    if (block) { block.style.setProperty('--mlys-seit', sek); block.classList.add('is-neu'); }
  }
  if (window.MutationObserver) {
    new MutationObserver(function () {
      scrollHalten();
      clearTimeout(jubelTimer);
      jubelTimer = setTimeout(jubel, 10);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* iOS: Seite hinter dem offenen Warenkorb festhalten (Tim 29.10.2026, Videos:
     Rabattcode-Feld antippen, Tastatur geht auf, der Warenkorb verschwindet und
     man sieht die Seite dahinter; nach dem Schliessen haengt er verschoben).
     1. Solange der Drawer offen ist, steht der body fest (position fixed an
        der alten Scrollposition), beim Schliessen geht es an genau dieselbe
        Stelle zurueck.
     2. Das Rabattfeld selbst liegt beim Aufklappen als Karte im oberen Drittel
        des Warenkorbs (CSS in snippets/mlys-ship-banner.liquid). Dort deckt die
        Tastatur es nicht ab, Safari muss nichts verschieben.
     3. Falls Safari trotzdem etwas verschiebt: beim Fokus und nach dem
        Verlassen eines Felds alles auf Scroll 0 zurueck (Fenster, Drawer,
        Drawer-Innenteil), die Produktliste behaelt ihre Position. */
  var sperreY = null;
  function seiteSperren(an) {
    var b = document.body;
    if (!b) return;
    if (an && sperreY === null) {
      sperreY = window.pageYOffset || document.documentElement.scrollTop || 0;
      b.style.position = 'fixed';
      b.style.top = -sperreY + 'px';
      b.style.left = '0';
      b.style.right = '0';
      b.style.width = '100%';
    } else if (!an && sperreY !== null) {
      var y = sperreY;
      sperreY = null;
      b.style.position = '';
      b.style.top = '';
      b.style.left = '';
      b.style.right = '';
      b.style.width = '';
      var wurzel = document.documentElement;
      var verhalten = wurzel.style.scrollBehavior;
      wurzel.style.scrollBehavior = 'auto';
      window.scrollTo(0, y);
      wurzel.style.scrollBehavior = verhalten;
    }
  }
  function zurueckSetzen() {
    if (sperreY !== null && (window.pageYOffset || 0) !== 0) window.scrollTo(0, 0);
    var teile = document.querySelectorAll('cart-drawer, #CartDrawer, cart-drawer .drawer__inner, cart-drawer .drawer__footer');
    for (var i = 0; i < teile.length; i++) { if (teile[i].scrollTop) teile[i].scrollTop = 0; }
  }
  function sperreBeobachten() {
    var d = document.querySelector('cart-drawer');
    if (!d || !window.MutationObserver) return;
    new MutationObserver(function () { seiteSperren(d.classList.contains('active')); })
      .observe(d, { attributes: true, attributeFilter: ['class'] });
    seiteSperren(d.classList.contains('active'));
    document.addEventListener('focusin', function (e) {
      if (!e.target || !e.target.closest || !e.target.closest('cart-drawer')) return;
      setTimeout(zurueckSetzen, 350);
    }, true);
    document.addEventListener('focusout', function (e) {
      if (!e.target || !e.target.closest || !e.target.closest('cart-drawer')) return;
      setTimeout(function () {
        if (!(document.activeElement && /INPUT|TEXTAREA/.test(document.activeElement.tagName))) zurueckSetzen();
      }, 120);
      setTimeout(zurueckSetzen, 500);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { abgleichen(); setTimeout(abgleichen, 3000); sperreBeobachten(); }, { once: true });
  } else {
    abgleichen();
    setTimeout(abgleichen, 3000); /* Nachkontrolle: Einlegen der vorigen Seite kann noch unterwegs sein */
    sperreBeobachten();
  }
})();